// Shipped and live — every entry is running in production today.
//
// This file no longer holds entries by hand: it renders the shared build log at
// changelog/entries.json (repo root), the single source every log surface reads.
// Update it with `trace log draft` → curate → `trace log publish` — never here.
import entries from '../../../../changelog/entries.json'

export interface ChangelogEntry {
  date: string
  title: string
  points: string[]
  /** The Log's tag — how this entry reads on the marketing teaser. */
  tag?: 'new' | 'improved' | 'fixed'
}

interface LogEntry {
  id: string
  date: string
  scope: string
  audience: string
  tag: string
  title: string
  body: string
  refs?: { pr?: number; commit?: string }
}

// The build log's tag vocabulary → the teaser's three words.
const TEASER_TAG: Record<string, ChangelogEntry['tag']> = {
  feature: 'new',
  fix: 'fixed',
}

// Keeper-facing entries only; a body line per bullet. The file is newest-first.
export const CHANGELOG: ChangelogEntry[] = (entries as LogEntry[])
  .filter((e) => e.audience === 'keeper')
  .map((e) => ({
    date: e.date,
    title: e.title,
    points: e.body.split('\n').filter((p) => p.trim().length > 0),
    tag: TEASER_TAG[e.tag] ?? 'improved',
  }))
